<template>
	<div class="pop pop-success" :class="{ show: successPop }">
		<div class="cont">
            <p class="t">{{ $t("bindSuccess") }}</p>
            <div class="dec"></div>
            <p>{{ $t("bindSuccess2") }}</p>
            <div class="btn-confirm" @click="popClose('success')">{{ $t('confirm') }}</div>
            <div class="pop-close" @click="popClose('success')"></div>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapState } from 'vuex'

	export default {
		name: 'pop-success',
		mounted() {

		},
		data() {
			return {}
		},
		components: {},
		computed: {
			...mapState(['pop']),
			successPop() {
				return this.$store.state.pop.success
			}
		},
		methods: {
			...mapMutations(['popOpen', 'popClose', 'updateState'])
		}
	}
</script>
